import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { Form as DXForm, GroupItem, SimpleItem, Tab, TabbedItem, TabPanelOptions } from 'devextreme-react/form'
import type { task } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DocumentPermissions } from '@/enums'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import AttachmentsManager from '@/components/file-manager/AttachmentsManager'
import { FileManagerRef } from 'devextreme-react/cjs/file-manager'
import { useRef } from 'react'

const TaskBriefDetail = (props: DataGridTypes.MasterDetailTemplateData) => {
  const task: task = props.data.data
  const fileManagerRef = useRef<FileManagerRef>(null)
  const { client } = useQsAdminApiManager()

  return (
    <div className={'dx-card responsive-paddings'}>
      <DXForm id={'task_brief_detail_form'} formData={task} labelLocation={'top'} readOnly={true}>
        <GroupItem colCount={5} colSpan={5}>
          <GroupItem colCount={1} colSpan={5}>
            <TabbedItem>
              <TabPanelOptions selectedIndex={1} />
              <Tab title="Allegati">
                <AttachmentsManager
                  fileManagerRef={fileManagerRef}
                  folderUrl={task?.attachmentsFolderUrl}
                  preliminarPermissionsAction={() => {
                    return Promise.resolve(DocumentPermissions.Read)
                  }}
                  createDirectoryAction={async (rootFolderPath: string, name: string, conflictBehavior: string) => {
                    return await client.post(
                      '/api/task/createfolder',
                      {
                        rootFolder: rootFolderPath,
                        newFolderName: name,
                        conflictBehavior,
                        objectId: task.id,
                      },
                      {
                        headers: {
                          'Content-Type': 'application/json',
                        },
                      },
                    )
                  }}
                />
              </Tab>
              <Tab title="Note Ordine">
                <SimpleItem
                  dataField={'ordine.note'}
                  editorType={'dxTextArea'}
                  label={{ visible: false }}
                  editorOptions={{ height: 200 }}
                />
              </Tab>
              <Tab title="Note">
                <SimpleItem
                  dataField="note"
                  label={{ visible: false }}
                  editorType="dxHtmlEditor"
                  editorOptions={{
                    stylingMode: 'filled',
                    valueType: 'html',
                    mediaResizing: {
                      enabled: true,
                    },
                    imageUpload: {
                      tabs: ['file', 'url'],
                      fileUploadMode: 'base64',
                    },
                    readOnly: true,
                  }}
                ></SimpleItem>
              </Tab>
              <Tab title="Note Completamento">
                <SimpleItem
                  dataField="note_completamento"
                  label={{ visible: false }}
                  editorType="dxHtmlEditor"
                  editorOptions={{
                    stylingMode: 'filled',
                    valueType: 'html',
                    mediaResizing: {
                      enabled: true,
                    },
                    imageUpload: {
                      tabs: ['file', 'url'],
                      fileUploadMode: 'base64',
                    },
                    readOnly: true,
                  }}
                ></SimpleItem>
              </Tab>
              <Tab title="Note Cliente">
                <SimpleItem
                  dataField="sede.azienda.note"
                  label={{ visible: false }}
                  editorType="dxHtmlEditor"
                  editorOptions={{
                    stylingMode: 'filled',
                    valueType: 'html',
                    mediaResizing: {
                      enabled: true,
                    },
                    imageUpload: {
                      tabs: ['file', 'url'],
                      fileUploadMode: 'base64',
                    },
                    readOnly: true,
                  }}
                ></SimpleItem>
              </Tab>
            </TabbedItem>
          </GroupItem>
        </GroupItem>
      </DXForm>
    </div>
  )
}

export default TaskBriefDetail
